import React, { FC, Fragment } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        formControlLabelCheckboxStyle: {
            width: 300,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const RemovalPersonalContributionUndergroundWorkForm: FC = () => {
    const classes = useStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.REMOVAL_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK
    >();

    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControlLabel
                isCheckBox={true}
                className={formControlClasses.formControlLabelCheckboxStyle}
                style={{ display: "flex" }}
                control={
                    <Checkbox
                        className={formControlClasses.checkboxStyle}
                        value="PersonalContributionCanDoUndergroundWork"
                        checked={values.removalPersonalContributionCanDoUndergroundWork.value.yes}
                        onChange={(event, checked) => {
                            setValues(values => {
                                values.removalPersonalContributionCanDoUndergroundWork.value.yes = checked;
                                values.removalPersonalContributionCanDoUndergroundWork.value.no = !checked;
                            });
                        }}
                    />
                }
                label="Tiefbau"
                error={values.removalPersonalContributionCanDoUndergroundWork.error !== null}
            />
            <p
                className={classes.pSmall}
                style={{ marginTop: 10, marginBottom: 15, marginLeft: 44 }}
            >
                Der Graben ab Kundengrundstück bis zur Gebäudeeinführung kann in Eigenleistung
                ausgeführt werden.
            </p>
        </Fragment>
    );
};
